import {
  Box as MuiBox,
  CircularProgress as MuiCircularProgress,
  useTheme,
} from '@mui/material';
import { Button, Dialog } from 'components';
import { FormAutocomplete, FormControl, Typography } from 'components/ui';
import { useTranslation } from 'react-i18next';
import CancelButton from 'components/Buttons/CancelButton';
import TableUserInfo from 'components/TableUserInfo';
import useCareTeamsForAutocompleteRequest from 'pagesAdmin/SettingsPage/TabSubOrgs/hooks/useCareTeamsForAutocompleteRequest';
import { useState } from 'react';
import { Form } from 'react-final-form';

const ReactivateDialog = (props) => {
  const { close, initialData } = props;
  const { t } = useTranslation();
  const { user } = initialData;
  const [search, setSearch] = useState('');

  const {
    careTeams,
    loadingCareTeams,
    loadMore: fetchMoreCareTeams,
  } = useCareTeamsForAutocompleteRequest(search);

  const theme = useTheme()
  
  return (
    <Dialog
      {...props}
      style={{ '.MuiPaper-root': { maxWidth: '800px' } }}
      title={initialData?.dialogTitle}
      onClose={close}
    >
      <Form onSubmit={() => {}}>
        {({ values }) => (
          <>
            <Typography
              style={{ color: theme.palette.colors.gray400, width: '520px' }}
              mb={5}
            >
              {initialData?.dialogWarningMessage}
            </Typography>
            <MuiBox style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
              <TableUserInfo isActive isPatient user={user} isDialog />
            </MuiBox>
            <FormControl
              label={t('Select a care team')}
              style={{ marginTop: 20 }}
            >
              <FormAutocomplete
                name="careTeam"
                options={careTeams}
                loading={loadingCareTeams}
                getOptionLabel={(option) => option.name}
                onScroll={fetchMoreCareTeams}
                placeholder={t('Type care team')}
                inputOnChange={(v) => setSearch(v)}
              />
            </FormControl>
            <MuiBox
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: '20px',
                gap: 1,
              }}
            >
              <MuiBox style={{ display: 'flex', gap: 10, marginLeft: 'auto' }}>
                <CancelButton
                  variant="outlined"
                  onClick={() => close({ isReactivated: false })}
                />
                <Button
                  style={{ height: 40 }}
                  icon={false}
                  onClick={() => close({ ...values, isReactivated: true })}
                  title={
                    initialData?.loading ? (
                      <div
                        style={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        <MuiCircularProgress
                          style={{ width: '20px', height: '20px' }}
                        />
                      </div>
                    ) : (
                      t('Reactivate')
                    )
                  }
                />
              </MuiBox>
            </MuiBox>
          </>
        )}
      </Form>
    </Dialog>
  );
};

export default ReactivateDialog;
